import { combineReducers } from '@reduxjs/toolkit';
import getSignedUrlReducer from './get-signed-url';
import getBase64FromUrlReducer from './get-base64-from-url';

const systemFileReducer = combineReducers({
  getSignedUrl: getSignedUrlReducer,
  getBase64FromUrl: getBase64FromUrlReducer
});

export default systemFileReducer;